export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiking gallery"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover our hikers' pictures"])}
}